module.exports = __webpack_public_path__ + "static/media/catalog.70f5d4c1.svg";